/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import defaultsDeep from 'lodash/defaultsDeep';
import { Container, Row, Column } from '../../../styles/Grid';
import Search from '../../ui/Search';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  containerPaddingCss,
  descriptionCss,
  headlineCss,
} from './index.styles';

export const defaultData = {
  BackgroundColor: { fields: { Value: { value: 'brown10' } } },
  Headline: { value: 'Where in the world do you want to work?' },
  Description: {
    value:
      "Our global network of workspaces enables you yo work wherever you need yo be - close to clients, partners, suppliers or home. Let's find the right workspace for you and your team.",
  },
  WorkspaceList: [
    {
      fields: {
        Label: {
          value: '',
        },
        QueryString: {
          value: '',
        },
      },
    },
  ],
};

class HomepageSearch extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);
    const { BackgroundColor, Description, Headline, WorkspaceList } = fields;
    const richFiltering = get(fields, 'RichFiltering.value', false);

    return (
      <Spacer
        backgroundColor={BackgroundColor}
        paddingCss={containerPaddingCss}
      >
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 7 }}>
              <h2 css={headlineCss}>
                <Text field={Headline} />
              </h2>
            </Column>
          </Row>
          <Row>
            <Column cols={{ sm: 6, md: 8, lg: 7 }}>
              <p css={descriptionCss}>
                <Text field={Description} />
              </p>
            </Column>
          </Row>
          <Search
            workspaceOptions={WorkspaceList}
            parent="homepage"
            richFiltering={richFiltering}
          />
        </Container>
      </Spacer>
    );
  }
}

HomepageSearch.displayName = 'HomepageSearch';

HomepageSearch.defaultProps = { fields: defaultData };

const BackgroundColorType = {
  fields: PropTypes.shape({
    Value: PropTypes.shape({ value: PropTypes.string }),
  }),
};

const workspaceOptionType = {
  fields: PropTypes.shape({
    Label: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  id: PropTypes.string,
  path: PropTypes.string,
};

HomepageSearch.propTypes = {
  BackgroundColor: PropTypes.shape(BackgroundColorType),
  Headline: PropTypes.shape({ value: PropTypes.string }),
  Description: PropTypes.shape({ value: PropTypes.string }),
  WorkspaceList: PropTypes.arrayOf(PropTypes.shape(workspaceOptionType)),
};

export default HomepageSearch;
